import React from 'react';
import Icon from '../../../components/AppIcon';

const RecommendationCard = ({ recommendation, isSelected, onClick, userRole }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'bg-error text-error-foreground';
      case 'medium':
        return 'bg-warning text-warning-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-warning/20 text-warning border-warning/30';
      case 'approved':
        return 'bg-success/20 text-success border-success/30';
      case 'rejected':
        return 'bg-error/20 text-error border-error/30';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'pending':
        return 'قيد المراجعة';
      case 'approved':
        return 'تمت الموافقة';
      case 'rejected':
        return 'مرفوض';
      default:
        return status;
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case 'high':
        return 'عالية';
      case 'medium':
        return 'متوسطة';
      case 'low':
        return 'منخفضة';
      default:
        return priority;
    }
  };

  const canApprove = () => {
    if (userRole === 'admin') return true;
    if (userRole === 'contract_specialist') return true;
    return false;
  };

  const matchCount = recommendation?.recommendationData?.propertyMatches?.length || 0;
  const topMatch = recommendation?.recommendationData?.propertyMatches?.[0];
  const urgencyLevel = recommendation?.recommendationData?.contractTiming?.urgencyLevel || 'متوسط';

  return (
    <div
      onClick={onClick}
      className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-250 hover:shadow-warm-md ${
        isSelected
          ? 'border-primary bg-primary/5 shadow-warm'
          : 'border-border bg-card hover:border-primary/50'
      }`}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-gradient-to-br from-primary/20 to-accent/20 flex items-center justify-center flex-shrink-0">
            <Icon name="Sparkles" size={24} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm md:text-base font-semibold text-foreground truncate">
              {recommendation?.clientName}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground truncate">
              {matchCount} عقار مطابق • {urgencyLevel}
            </p>
          </div>
        </div>
        <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getPriorityColor(recommendation?.priority)}`}>
          {getPriorityLabel(recommendation?.priority)}
        </span>
      </div>
      <div className="flex items-center gap-2 mb-3">
        <span className={`px-3 py-1 rounded-lg text-xs font-medium border ${getStatusColor(recommendation?.approvalStatus)}`}>
          {getStatusLabel(recommendation?.approvalStatus)}
        </span>
        {topMatch && (
          <span className="text-xs text-muted-foreground">
            أعلى تطابق: {topMatch?.matchScore}%
          </span>
        )}
      </div>
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <div className="flex items-center gap-1">
          <Icon name="Calendar" size={14} />
          <span>{new Date(recommendation?.createdAt)?.toLocaleDateString('ar-EG')}</span>
        </div>
        {canApprove() && recommendation?.approvalStatus === 'pending' && (
          <div className="flex items-center gap-1 text-primary">
            <Icon name="CheckCircle" size={14} />
            <span className="font-medium">يتطلب موافقتك</span>
          </div>
        )}
      </div>
      {recommendation?.sentToClient && (
        <div className="mt-2 pt-2 border-t border-border">
          <div className="flex items-center gap-1 text-xs text-success">
            <Icon name="Send" size={14} />
            <span>تم الإرسال للعميل</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecommendationCard;